var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 4.5,
    stroke: "#808086"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4438 10.4674C12.9813 10.9058 13.25 11.1251 13.25 11.5C13.25 11.8749 12.9813 12.0942 12.4438 12.5326C12.2954 12.6536 12.1483 12.7676 12.0131 12.8625C11.8944 12.9458 11.7601 13.032 11.621 13.1166C11.0848 13.4427 10.8167 13.6057 10.5762 13.4252C10.3358 13.2447 10.3139 12.8668 10.2702 12.1111C10.2578 11.8973 10.25 11.6878 10.25 11.5C10.25 11.3122 10.2578 11.1027 10.2702 10.8889C10.3139 10.1332 10.3358 9.7553 10.5762 9.5748C10.8167 9.39429 11.0848 9.55733 11.621 9.8834C11.7601 9.96798 11.8944 10.0542 12.0131 10.1375C12.1483 10.2324 12.2954 10.3464 12.4438 10.4674Z",
    stroke: "#808086"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivate);
export default __webpack_public_path__ + "static/media/activate.0f1ec00762ba08ea4656d3400accf38b.svg";
export { ForwardRef as ReactComponent };